import { render, staticRenderFns } from "./ListItemCalendar.vue?vue&type=template&id=564d5fe2&"
import script from "./ListItemCalendar.vue?vue&type=script&lang=js&"
export * from "./ListItemCalendar.vue?vue&type=script&lang=js&"
import style0 from "./ListItemCalendar.vue?vue&type=style&index=0&id=564d5fe2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports